export default {
  title: 'Mes produits',
  noProductsText: "Aucun contrat n'est disponible. Si vous avez souscrit un nouveau contrat ou modifié un contrat existant, veuillez réessayer dans les 24 h à 48 h. Si le problème persiste, veuillez contacter le ",
  customerService: 'service à la clientèle.',
  contractNumberLabel: 'Numéro de contrat :',
};
